import React, { useEffect, useState } from "react";

const COOKIE_NAME = "color-theme";

export default function ThemeToggle() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const theme = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${COOKIE_NAME}=`))
      ?.split("=")[1];

    if (theme === "dark") {
      document.documentElement.classList.add("dark");
      setIsDark(true);
    } else {
      document.documentElement.classList.remove("dark");
      setIsDark(false);
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = isDark ? "light" : "dark";
    setIsDark(!isDark);

    document.documentElement.classList.toggle("dark", !isDark);

    // Set cookie for 1 year
    document.cookie = `${COOKIE_NAME}=${newTheme}; path=/; max-age=31536000`;
  };

  return (
    <button
      onClick={toggleTheme}
      className="px-4 py-2 border rounded text-sm bg-gray-200 dark:bg-gray-700 dark:text-white"
    >
      {isDark ? "🌞 Light Mode" : "🌙 Dark Mode"}
    </button>
  );
}
